import AffiliationShape, { getNeedsEmailConf } from 'shapes/Affiliation';
import AlertDialog from 'components/AlertDialog.jsx';
import DeviceActions from 'actions/DeviceActions';
import { SchoolCrownBadge } from 'admin/components/AdminVerifiedModal.jsx';
import React from 'react';
import ToastActions from 'actions/ToastActions';
import YouTubeEmbed from 'components/YouTubeEmbed.jsx';

import { VIDEO_URL } from 'admin/constants/AdminRoles';

import './styles/AdminVerificationModal.scss';

class AdminNeedsEmailConfModal extends React.Component {
  static propTypes = {
    affiliation: AffiliationShape.isRequired,
    onRequestHide: React.PropTypes.func.isRequired,
    orgName: React.PropTypes.string.isRequired,
  };

  resendConf = () => {
    const email = getNeedsEmailConf(this.props.affiliation).official_email;
    DeviceActions.resendConfirmationEmail(email).then(
      () => ToastActions.showSuccessToast('Sent! Please check your email in a few minutes'),
      (error) => ToastActions.showAPIError(error)
    );
  };

  render() {
    return (
      <AlertDialog
        eventScreenName="AdminNeedsEmailConfModal"
        ref="dialog"
        size="small"
        className="AdminVerificationModal"
        headerImageComponent={<SchoolCrownBadge />}
        title="Get the new Remind for Schools"
        subtext={`Confirm your email address to access features that support better communication at ${this.props.orgName}.`}
        buttonText="Resend confirmation email"
        closeLinkText="Not right now"
        onOkay={this.resendConf}
        onRequestHide={this.props.onRequestHide}>
        <YouTubeEmbed
          className="AdminVerificationModal-video"
          width={392}
          height={220}
          src={VIDEO_URL}
        />
      </AlertDialog>
    );
  }
}

export default AdminNeedsEmailConfModal;



// WEBPACK FOOTER //
// ./src/admin/components/AdminNeedsEmailConfModal.jsx